import { JSX, useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function CadAutoSubmitForm({
  cadFormData,
}: {
  cadFormData: {
    url: string;
    method: string;
    body: Record<string, string | number | boolean>;
  } | null;
}): JSX.Element | null {
  const [open, setOpen] = useState(cadFormData !== null);
  const [prevCadFormData, setPrevCadFormData] = useState(cadFormData);
  if (cadFormData !== prevCadFormData) {
    setPrevCadFormData(cadFormData);
    setOpen(cadFormData !== null);
  }
  const [iframeNode, setIframeNode] = useState<HTMLIFrameElement | null>(null);

  useEffect(() => {
    if (!open || !cadFormData || !iframeNode) return;

    const doc = iframeNode.contentDocument;
    if (!doc) return;

    const form = doc.createElement("form");
    form.method = cadFormData.method;
    form.action = cadFormData.url;
    form.target = "_self";
    Object.entries(cadFormData.body).forEach(([key, value]) => {
      const input = doc.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });
    doc.body.appendChild(form);
    form.submit();
  }, [open, cadFormData, iframeNode]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth={false}
      sx={{
        "& .MuiDialog-paper": {
          width: "auto",
        },
      }}
    >
      <DialogTitle>CAD Viewer</DialogTitle>
      <DialogContent sx={{ py: 0, pl: 2 }}>
        <iframe
          ref={setIframeNode}
          style={{
            border: "none",
            width: "945px",
            height: "465px",
          }}
        />
      </DialogContent>
      <DialogActions sx={{ pt: 0 }}>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
